import { useMemo, useContext } from 'react';
import { InlineCommentsStateContext } from '../context';
export const useInlineCommentsFilter = ({
  annotationIds,
  filter: {
    state: stateFilter
  }
}) => {
  const states = useContext(InlineCommentsStateContext);
  return useMemo(() => {
    return annotationIds.reduce((acc, id) => {
      if (states && states[id] === stateFilter) {
        return [...acc, id];
      }
      return acc;
    }, []);
  }, [annotationIds, states, stateFilter]);
};